<div class="pane-header">
  <h3 class="title">Edit Table</h3>
  <div class="actions">
    <span class="close">
      {{{ icon 'close' 'Close' }}}
    </span>
  </div>
</div>
<div class="pane-body">
  <div class="pane-body-preview">

  </div>
  <div class="pane-body-editor">
    <fieldset class="cell-tools">
      <ul class="loaded-tools">
        <li class="loaded-tools-header">
          <span>Manage Cell</span>
        </li>
        <li>
          <h3>Content</h3>
          <div class="editor-container"></div>
        </li>
        <li class="alignment-tools">
          <h3>Alignment</h3>
          <button class="pane-body-editor-button cell-align-left">
            {{{ icon "align-left" }}}
          </button>
          <button class="pane-body-editor-button cell-align-center">
            {{{ icon "align-center" }}}
          </button>
          <button class="pane-body-editor-button cell-align-right">
            {{{ icon "align-right" }}}
          </button>
          <button class="pane-body-editor-button cell-align-justify">
            {{{ icon "align-justify" }}}
          </button>
        </li>
      </ul>
    </fieldset>

    <fieldset class="row-tools">
      <ul class="loaded-tools">
        <li class="loaded-tools-header">
          <span>Manage Row</span>
        </li>
        <li class="check-box-group">
          <label for="stripe_rows">
            <input type="checkbox" class="row-header-toggle" value="1" />
            <span>Header Row</span>
          </label>
        </li>
        <li class="alignment-tools">
          <h3>Alignment</h3>
          <button class="pane-body-editor-button row-align-left">
            {{{ icon "align-left" }}}
          </button>
          <button class="pane-body-editor-button row-align-center">
            {{{ icon "align-center" }}}
          </button>
          <button class="pane-body-editor-button row-align-right">
            {{{ icon "align-right" }}}
          </button>
          <button class="pane-body-editor-button row-align-justify">
            {{{ icon "align-justify" }}}
          </button>
        </li>
        <li>
          <h3>Move This Row</h3>
          <button class="pane-body-editor-button move-row-up">Move Up</button>
          <button class="pane-body-editor-button move-row-down">Move Down</button>
        </li>
        <li>
          <h3>Add New Row</h3>
          <button class="pane-body-editor-button insert-row-above">Insert Above</button>
          <button class="pane-body-editor-button insert-row-below">Insert Below</button>
        </li>
        <li>
          <button class="pane-body-editor-button-delete delete-row">Delete this Row</button>
        </li>
      </ul>
    </fieldset>

    <fieldset class="column-tools">
      <ul class="loaded-tools">
        <li class="loaded-tools-header">
          <span>Manage Column</span>
        </li>
        <li class="alignment-tools">
          <h3>Alignment</h3>
          <button class="pane-body-editor-button col-align-left">
            {{{ icon "align-left" }}}
          </button>
          <button class="pane-body-editor-button col-align-center">
            {{{ icon "align-center" }}}
          </button>
          <button class="pane-body-editor-button col-align-right">
            {{{ icon "align-right" }}}
          </button>
          <button class="pane-body-editor-button col-align-justify">
            {{{ icon "align-justify" }}}
          </button>
        </li>
        <li>
          <h3>Move This Column</h3>
          <button class="pane-body-editor-button move-col-left">Move Left</button>
          <button class="pane-body-editor-button move-col-right">Move Right</button>
        </li>
        <li>
          <h3>Add New Column</h3>
          <button class="pane-body-editor-button insert-col-before">Insert Before</button>
          <button class="pane-body-editor-button insert-col-after">Insert After</button>
        </li>
        <li>
          <button class="pane-body-editor-button-delete delete-col">Delete this Column</button>
        </li>
      </ul>
    </fieldset>

    <fieldset>
      <ul class="loaded-tools">
        <li class="loaded-tools-header">
          <span>Table Options</span>
        </li>
        <li class="check-box-group">
          <label for="stripe_rows">
            <input type="checkbox" class="stripe-table-toggle" value="1" />
            <span>Stripe Rows</span>
          </label>
        </li>
        <li>
          <button class="pane-body-editor-button insert-row">Add Row</button>
          <button class="pane-body-editor-button insert-col">Add Column</button>
        </li>
      </ul>
    </fieldset>
  </div>
</div>
<div class="pane-footer"></div>
